
import m from "mithril";
import { getMithril } from "../utils.js";
import toast from "../js/toaster.js";
import PaginationBar from "./components/PaginationBar.js";

const DaftarSimpanan = {
    oninit: function () {
        this.summaryData = [];
        this.loading = true;
        this.expandedCustomerId = null;
        this.customerAccounts = {}; // Cache for customer details: { customerId: [accounts] }
        this.loadingDetails = {}; // Loading state for specific customers: { customerId: boolean }
        this.searchQuery = "";
        this.page = 1;
        this.limit = 50;
        this.totalPages = 1;
        this.totalRecords = 0;

        this.fetchSummary();
    },

    fetchSummary: async function () {
        this.loading = true;
        try {
            const searchParam = this.searchQuery ? `&search=${encodeURIComponent(this.searchQuery)}` : '';
            const url = `/api/savings-accounts?mode=summary&page=${this.page}&limit=${this.limit}${searchParam}`;

            const response = await getMithril(url);
            if (response.success) {
                this.summaryData = response.data;
                if (response.pagination) {
                    this.page = response.pagination.currentPage;
                    this.totalPages = response.pagination.totalPages;
                    this.totalRecords = response.pagination.totalRecords;
                }
            } else {
                toast.show("Gagal memuat data ringkasan simpanan", "error");
            }
        } catch (error) {
            console.error(error);
            toast.show("Terjadi kesalahan sistem", "error");
        } finally {
            this.loading = false;
            m.redraw();
        }
    },

    fetchCustomerAccounts: async function (customerId) {
        if (this.customerAccounts[customerId]) return; // Already loaded

        this.loadingDetails[customerId] = true;
        m.redraw();
        try {
            const response = await getMithril(`/api/savings-accounts?customerId=${customerId}`);
            if (response.success) {
                this.customerAccounts[customerId] = response.data;
            } else {
                toast.show("Gagal memuat rincian rekening", "error");
            }
        } catch (error) {
            console.error(error);
            toast.show("Terjadi kesalahan saat memuat rincian", "error");
        } finally {
            this.loadingDetails[customerId] = false;
            m.redraw();
        }
    },

    toggleDetails: function (customerId) {
        if (this.expandedCustomerId === customerId) {
            this.expandedCustomerId = null;
        } else {
            this.expandedCustomerId = customerId;
            this.fetchCustomerAccounts(customerId);
        }
    },

    view: function () {
        return m("div", { class: "p-6" }, [
            m("div", { class: "flex justify-between items-center mb-6" }, [
                m("h1", { class: "text-2xl font-bold text-gray-800 dark:text-white" }, "Daftar Simpanan"),
                m("div", { class: "flex space-x-2" }, [
                    m("input", {
                        type: "text",
                        class: "px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white",
                        placeholder: "Cari nasabah...",
                        value: this.searchQuery,
                        oninput: (e) => {
                            this.searchQuery = e.target.value;
                            this.page = 1; // Reset to page 1 on search
                        },
                        onkeypress: (e) => {
                            if (e.key === 'Enter') this.fetchSummary();
                        }
                    }),
                    m("button", {
                        class: "px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500",
                        onclick: () => this.fetchSummary()
                    }, "Cari")
                ])
            ]),

            this.loading ? m("div", { class: "text-center p-4 text-gray-500" }, "Memuat data...") :
                m("div", { class: "bg-white dark:bg-gray-800 shadow-md rounded-lg overflow-hidden" }, [
                    m("div", { class: "overflow-x-auto" }, [
                        m("table", { class: "min-w-full divide-y divide-gray-200 dark:divide-gray-700" }, [
                            m("thead", { class: "bg-gray-50 dark:bg-gray-700" }, [
                                m("tr", [
                                    m("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" }, "No"),
                                    m("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" }, "No. Reg"),
                                    m("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" }, "Nama Nasabah"),
                                    m("th", { class: "px-6 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" }, "Jumlah Rekening"),
                                    m("th", { class: "px-6 py-3 text-right text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" }, "Total Saldo"),
                                    m("th", { class: "px-6 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" }, "Aksi"),
                                ])
                            ]),
                            m("tbody", { class: "bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700" },
                                this.summaryData.length === 0 ?
                                    m("tr", [
                                        m("td", { colspan: 6, class: "px-6 py-4 text-center text-gray-500 dark:text-gray-400" }, "Tidak ada data simpanan")
                                    ]) :
                                    this.summaryData.map((item, index) => [
                                        m("tr", {
                                            class: `hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors cursor-pointer ${this.expandedCustomerId === item.customer_id ? "bg-orange-50 dark:bg-gray-700" : ""}`,
                                            onclick: () => this.toggleDetails(item.customer_id)
                                        }, [
                                            m("td", { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" }, index + 1),
                                            m("td", { class: "px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 dark:text-gray-100" }, item.no_reg || "-"),
                                            m("td", { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-700 dark:text-gray-300" }, item.nama_nasabah),
                                            m("td", { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-700 dark:text-gray-300 text-center" }, item.account_count),
                                            m("td", { class: "px-6 py-4 whitespace-nowrap text-sm font-bold text-gray-900 dark:text-white text-right" },
                                                new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR' }).format(Number(item.total_balance))
                                            ),
                                            m("td", { class: "px-6 py-4 whitespace-nowrap text-sm text-center" },
                                                m("button", {
                                                    class: "text-orange-500 hover:text-orange-700 focus:outline-none",
                                                    title: "Lihat Rincian"
                                                }, m("i", { class: `ri-arrow-${this.expandedCustomerId === item.customer_id ? 'up' : 'down'}-s-line text-xl` }))
                                            )
                                        ]),
                                        this.expandedCustomerId === item.customer_id ? m("tr", [
                                            m("td", { colspan: 6, class: "px-0 py-0 bg-gray-50 dark:bg-gray-900/50" }, [
                                                m("div", { class: "p-4 pl-12" }, [
                                                    this.loadingDetails[item.customer_id] ?
                                                        m("div", { class: "text-center py-2 text-gray-500" }, "Memuat rincian...") :
                                                        m("table", { class: "min-w-full divide-y divide-gray-200 dark:divide-gray-700 border border-gray-200 dark:border-gray-700 rounded-md" }, [
                                                            m("thead", { class: "bg-gray-100 dark:bg-gray-800" }, [
                                                                m("tr", [
                                                                    m("th", { class: "px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase" }, "No. Rekening"),
                                                                    m("th", { class: "px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase" }, "Produk"),
                                                                    m("th", { class: "px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase" }, "Tgl Buka"),
                                                                    m("th", { class: "px-4 py-2 text-center text-xs font-medium text-gray-500 uppercase" }, "Status"),
                                                                    m("th", { class: "px-4 py-2 text-right text-xs font-medium text-gray-500 uppercase" }, "Saldo")
                                                                ])
                                                            ]),
                                                            m("tbody", { class: "bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700" },
                                                                (this.customerAccounts[item.customer_id] || []).length === 0 ?
                                                                    m("tr", [
                                                                        m("td", { colspan: 5, class: "px-4 py-2 text-sm text-gray-500 text-center" }, "Tidak ada rekening aktif")
                                                                    ]) :
                                                                    (this.customerAccounts[item.customer_id] || []).map(acc =>
                                                                        m("tr", [
                                                                            m("td", { class: "px-4 py-2 text-sm font-mono text-gray-700 dark:text-gray-300" }, acc.account_number),
                                                                            m("td", { class: "px-4 py-2 text-sm text-gray-700 dark:text-gray-300" }, acc.product_name),
                                                                            m("td", { class: "px-4 py-2 text-sm text-gray-700 dark:text-gray-300" }, new Date(acc.opening_date).toLocaleDateString('id-ID')),
                                                                            m("td", { class: "px-4 py-2 text-sm text-center" },
                                                                                m("div", { class: "flex flex-col items-center gap-1" }, [
                                                                                    m("span", {
                                                                                        class: `px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${acc.status === 'active' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`
                                                                                    }, acc.status === 'active' ? 'Aktif' : 'Non-Aktif'),
                                                                                    acc.minimum_balance_breach_since ? m("span", {
                                                                                        class: "px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-amber-100 text-amber-800 dark:bg-amber-900/50 dark:text-amber-300",
                                                                                        title: `Saldo di bawah minimum sejak ${new Date(acc.minimum_balance_breach_since).toLocaleDateString('id-ID')}`
                                                                                    }, "⚠ Akan Didebet") : null
                                                                                ])
                                                                            ),
                                                                            m("td", { class: "px-4 py-2 text-sm text-right font-medium text-gray-900 dark:text-white" },
                                                                                new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR' }).format(acc.balance)
                                                                            )
                                                                        ])
                                                                    )
                                                            )
                                                        ])
                                                ])
                                            ])
                                        ]) : null
                                    ])
                            )
                        ])
                    ]),
                    m(PaginationBar, {
                        page: this.page,
                        totalPages: this.totalPages,
                        totalRecords: this.totalRecords,
                        limit: this.limit,
                        itemLabel: "data",
                        onPageChange: (newPage) => {
                            this.page = newPage;
                            this.fetchSummary();
                        }
                    })
                ])
        ]);
    }
};

export default DaftarSimpanan;
